import TestPhotoEdit from "./TestPhotoEdit";
import PhotoEdit from "./PhotoEdit";
function App() {
  return (
    <div className="laedit m-app container-fluid px-0">
      {/* <TestPhotoEdit /> */}
      <PhotoEdit />
    </div>
  );
}
export default App;
